import { Component, Input } from '@angular/core';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
	selector: 'app-data-set-loading-row',
	template: `
		<table [class.loading-wrapper]="loadingWrapper">
			<tr class="mat-row">
				<td class="mat-cell" [class.no-border]="noBorder">
					<mat-spinner diameter="25" style="float: left"></mat-spinner>
					<div
						style="float: left; margin-left: 1em"
						data-automation-id="dataSetTable-loadingRecords"
						i18n="@@dataSetTable-loadingRecords"
					>
						Loading records...
					</div>
				</td>
			</tr>
		</table>
	`,
	imports: [MatProgressSpinner],
})
export class DataSetLoadingRowComponent {
	@Input() noBorder = false;
	@Input() loadingWrapper = false;
}
